var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#151e2d","fillRule":"evenodd","transform":"translate(0 -1)"},[React.createElement("path",{"d":"m-.14426194 8.8h23.10000004l-2.1924217 2.2-22.9633164-.1442619z","transform":"matrix(.70710678 .70710678 -.70710678 .70710678 10.039965 -4.438619)","key":0}),React.createElement("path",{"d":"m-2.2 8.8h23.1l2.0221184 2.0221184-22.9013455.1986545z","transform":"matrix(.70710678 -.70710678 .70710678 .70710678 -3.973017 10.22906)","key":1})]));
}

IconClose.defaultProps = {"height":"18","viewBox":"0 0 20 18","width":"20"};

module.exports = IconClose;

IconClose.default = IconClose;
